<template>
  <div>
    <h4>{{ title }}</h4>
    <v-layout align-center>
      <v-flex xs2>
        <v-radio-group
          :input-value="settings.type"
          @change="onTypeChange"
        >
          <v-radio
            v-for="item in backgroundTypes"
            :key="item"
            :label="item"
            :value="item"
          ></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs4>
        <v-layout row wrap>
          <v-flex>
            <e-color-picker
              :label="bgColorLabel"
              :value="settings.gradient.from"
              @colorChange="onColorChange('from', $event)"
            />
          </v-flex>
          <v-flex
            v-if="isGradient"
          >
            <e-color-picker
              label="color 2"
              :value="settings.gradient.to"
              @colorChange="onColorChange('to', $event)"
            />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import EColorPicker from '@/components/shared/EColorPicker'
  import { assocPath } from 'ramda'
  import {
    backgroundValidator,
    BG_TYPES,
    generateDefaultBackgroundParams,
    getColorsParams
  } from './../styleForms/utils'

  export default {
    name: 'BackgroundColorSettings',
    components: {
      EColorPicker
    },
    props: {
      title: {
        type: String,
        default: 'Background:'
      },
      settings: {
        type: Object,
        validator: backgroundValidator,
        default: generateDefaultBackgroundParams
      }
    },
    data () {
      return {
        backgroundTypes: Object.keys(BG_TYPES)
          .map( type => BG_TYPES[type])
      }
    },
    computed: {
      isGradient () {
        return this.settings.type === BG_TYPES.GRADIENT
      },
      bgColorLabel () {
        return this.isGradient ? 'color 1' : 'color'
      }
    },
    methods: {
      setColor (key, color, settingsObj = this.settings) {
        return assocPath(
          ['gradient', key],
          getColorsParams(color),
          settingsObj
        )
      },
      onColorChange (key, color){
        const newSettings = this.isGradient
          ? this.setColor(key, color)
          : this.setColor(
              'to',
              color,
              this.setColor('from', color)
            )
        this.updateSettings(newSettings)
      },
      onTypeChange (ev) {
        this.updateSettings({
          ...this.settings,
          type: ev
        })
      },
      updateSettings (newSettingsObj) {
        this.$emit('update:settings', newSettingsObj)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleSettingsFormComponents/BackgroundColorSettings.vue